import SrSupplementBox from "./index.vue";

SrSupplementBox.install = function(Vue) {
  Vue.component(SrSupplementBox.name, SrSupplementBox);
};

export default SrSupplementBox;



// WEBPACK FOOTER //
// ./packages/SrSupplementBox/index.js